import { ArrayElement, TypeOrArray } from "@hex-insights/core";
import { ExportButton as BaseExportButton, ExportButtonProps as BaseExportButtonProps } from "../../../Components";
import {
	NewsletterFilterInput,
	NewsletterIndexDocument,
	NewsletterIndexQuery,
	NewsletterOrderField,
	NewsletterPaginationDocument,
} from "../../../Utilities";
import { NewsletterFormat, UserFormat } from "../../Format";

const columnNames = ["id", "title", "body", "status", "releaseAt", "author"] as const;

type Column = ArrayElement<typeof columnNames>;

type Node = NewsletterIndexQuery["newsletterConnection"]["edges"][0]["node"];

type ExportButtonProps = Omit<
	BaseExportButtonProps<Node, TypeOrArray<NewsletterFilterInput>, NewsletterOrderField | null, Column>,
	"dataQuery" | "paginationQuery" | "fileNamePrefix" | "resultKey" | "columns" | "formatRow"
> & {
	columns?: Record<string, boolean>;
};

export function ExportButton({ queryVariables, resultsPerPage, columns }: ExportButtonProps) {
	const activeColumnNames = columnNames.filter((e) => e === "id" || (columns?.[e] ?? true));

	return (
		<BaseExportButton<Node, TypeOrArray<NewsletterFilterInput>, NewsletterOrderField | null, Column>
			queryVariables={queryVariables}
			dataQuery={NewsletterIndexDocument}
			paginationQuery={NewsletterPaginationDocument}
			resultsPerPage={resultsPerPage}
			fileNamePrefix="newsletters"
			resultKey="newsletterConnection"
			columns={activeColumnNames}
			formatRow={formatRow}
		/>
	);
}

function formatRow(node: Node): Record<Column, any> {
	return {
		id: node.id,
		title: NewsletterFormat.Fields.title(node.title),
		body: NewsletterFormat.Fields.body(node.body),
		status: NewsletterFormat.status(node),
		releaseAt: NewsletterFormat.Fields.releaseAt(node.releaseAt),
		author: node.author ? UserFormat.name(node.author) : "",
	};
}
